export enum NotificationType {
  DIALOG_SUCCESS,
  DIALOG_WARNING,
  DIALOG_ERROR,
  DIALOG_INFO,
  DIALOG_CONFIRMATION,
  DIALOG_ERROR_CONFIRMATION
}
